import { Divider, Grid, Paper, useTheme } from "@mui/material";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { useNavigate } from "react-router-dom";

export default function InvoicePortal() {
    const theme = useTheme();
    return (
        <div
            style={{
                position: "relative",
                textAlign: "center",
                height: "100%",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    top: "20%",
                    left: "50%",
                    height: "100px",
                    width: "60%",
                    minWidth: 900,
                    transform: "translate(-50%, -50%)",
                }}
            >
                <h1 style={{ paddingBottom: 40 }}>
                    Let's get you paid
                    <span style={{ color: theme.palette.primary.main }}>.</span>
                </h1>
                <Grid container justifyContent={"center"}>
                    <Grid item>
                        <Grid
                            container
                            spacing={2}
                            justifyContent={"space-between"}
                        >
                            <Grid item>
                                <OptionButton
                                    icon={
                                        <AutoAwesomeRoundedIcon
                                            sx={{ color: "#148451" }}
                                        />
                                    }
                                    title={"Get started."}
                                    description={
                                        <span>
                                            Haven't registered with Makers yet?{" "}
                                            <br />
                                            Let's get you set up.
                                        </span>
                                    }
                                    route={"/ap/vendor"}
                                />
                            </Grid>
                            <Grid item>
                                <OptionButton
                                    icon={
                                        <CloudUploadRoundedIcon
                                            sx={{ color: "#148451" }}
                                        />
                                    }
                                    title={"Upload an invoice."}
                                    description={
                                        <span>
                                            Already registered on this portal?{" "}
                                            <br />
                                            Then you just need to upload your
                                            invoice.
                                        </span>
                                    }
                                    route={"/ap/invoice"}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Divider
                    sx={{ width: "100%", marginTop: 5, marginBottom: 5 }}
                />
                <p style={{ marginTop: 15, fontSize: 12, textAlign: "left" }}>
                    Consectetur nisl bibendum elit lectus sed. Velit venenatis
                    consequat malesuada molestie urna neque faucibus id ac.
                    Tincidunt justo ipsum varius erat tortor enim in maecenas.
                    Bibendum consequat egestas fusce aliquam. Phasellus neque
                    varius amet suscipit porttitor. Scelerisque mattis sed
                    suscipit venenatis malesuada tempor.
                </p>
            </div>
        </div>
    );
}

const OptionButton = ({ icon, title, description, route }) => {
    const navigate = useNavigate();
    const goToRoute = () => {
        navigate(route);
    };
    return (
        <Paper
            sx={{
                boxShadow: "none",
                padding: 4,
                borderRadius: 6,
                cursor: "pointer",
            }}
            onClick={goToRoute}
        >
            <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
            >
                <Grid item>
                    <Grid container alignItems={"center"} spacing={3}>
                        <Grid item>
                            <div
                                style={{
                                    background: "#D4F3E5",
                                    padding: 20,
                                    width: 25,
                                    height: 25,
                                    borderRadius: "50%",
                                    position: "relative",
                                }}
                            >
                                {icon}
                            </div>
                        </Grid>
                        <Grid item style={{ textAlign: "left" }}>
                            <h4 style={{ margin: 0, fontSize: 14 }}>{title}</h4>
                            <p style={{ marginTop: 15, fontSize: 12 }}>
                                {description}
                            </p>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item paddingLeft={5}>
                    <ArrowForwardRoundedIcon />
                </Grid>
            </Grid>
        </Paper>
    );
};
